module.exports = __webpack_public_path__ + "static/media/logo_primario_bianco.40307f6e.svg";